import { render, staticRenderFns } from "./ShareToggle.vue?vue&type=template&id=3f6c6c04&"
import script from "./ShareToggle.vue?vue&type=script&lang=js&"
export * from "./ShareToggle.vue?vue&type=script&lang=js&"
import style0 from "./ShareToggle.vue?vue&type=style&index=0&id=3f6c6c04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports